var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pt-10 px-6 pb-20 body"
  }, [_vm._l(_vm.addresses, function (addr) {
    return _c('div', {
      key: 'address-' + addr.id,
      staticClass: "mb-5 last:mb-0 flex items-center bg-neutral-200 border border-neutral-300 rounded-md py-3 px-4 gap-3 cursor-pointer",
      on: {
        "click": function click($event) {
          return _vm.modifyAddress(addr.id);
        }
      }
    }, [_vm.iconsMapping[addr.asset_icon_id] ? _c('img', {
      attrs: {
        "src": _vm.iconsMapping[addr.asset_icon_id]
      }
    }) : _c('img', {
      attrs: {
        "src": require("@/assets/images/icons/home.svg")
      }
    }), _c('div', [_c('div', {
      staticClass: "flex gap-3 mb-1"
    }, [_c('p', {
      staticClass: "font-medium text-sm "
    }, [_vm._v(_vm._s(addr.location_label))]), addr.is_main ? _c('p', {
      staticClass: "text-xs text-neutral-500 bg-neutral-300 py-1 px-2 rounded-md"
    }, [_vm._v("Utama")]) : _vm._e()]), _c('p', {
      staticClass: "font-medium text-xs text-neutral-500 ellipsis",
      attrs: {
        "title": addr.address
      }
    }, [_vm._v(_vm._s(addr.address) + ", " + _vm._s(addr.detail_address))])])]);
  }), _c('div', {
    staticClass: "px-6 py-6 bg-white fixed bottom-0 left-0 z-1 w-full"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Tambah Alamat",
      "size": "full"
    },
    on: {
      "action": function action($event) {
        return _vm.addAddress();
      }
    }
  })], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }